// The one provable sync-truth line: counts what is verifiably still on this
// device only (queued submits/handoffs, receipts waiting to upload, unsaved
// slip edits). It never claims more than it knows.
//
// Shared by TopNav's account menu AND the crash-recovery screen — after the
// 2026-07-24 brick, "clear the app's website data" advice destroyed a receipt
// that existed only in this device's storage. Anywhere a pilot (or anyone
// helping them) decides whether clearing/reinstalling is safe must be able to
// see this count first.
import { pendingSubmitCount } from "./submitQueue";

export function computeSyncSummary() {
  let waiting = 0;
  try {
    waiting += pendingSubmitCount();
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (k.startsWith("pilotSlipUnsaved_")) waiting++;
      if (k.startsWith("expenseReport_")) {
        try {
          const r = JSON.parse(localStorage.getItem(k));
          waiting += (r?.receipts || []).filter((x) => x.pendingUpload).length;
        } catch { /* unreadable report */ }
      }
    }
  } catch { /* storage unavailable */ }
  return waiting
    ? { waiting, text: `${waiting} item${waiting > 1 ? "s" : ""} on this device waiting to sync; goes automatically when online` }
    : { waiting: 0, text: "Nothing waiting to sync on this device" };
}
